module.exports = __webpack_public_path__ + "img/89.5791b5f1.jpg";